import jwtDecode from "jwt-decode";
import { decryptUserId } from "../../utils/decryptUID";

export const hasToken = () => {
  const _search = new URLSearchParams(
    window.location.search
  );

  return (
    _search.has("token") &&
    (_search.get("token") || "").length > 0
  );
};

export const hasENUID = () => {
  const _search = new URLSearchParams(
    window.location.search
  );

  return (
    _search.has("enuid") &&
    (_search.get("enuid") || "").length > 0
  );
};

export const getToken = () => {
  const _search = new URLSearchParams(
    window.location.search
  );

  return _search.get("token") || "";
};

export const getEnv = () => {
  const _search = new URLSearchParams(
    window.location.search
  );

  return _search.get("env") || "";
};

export const getENUserId = () => {
  const _search = new URLSearchParams(
    window.location.search
  );

  return _search.get("enuid") || "";
};

// export const getUserId = () => {
//   if (!hasToken()) {
//     return "";
//   }

//   const _token = getToken();
//   const _userId = jwtDecode<{ data: { user_id: string } }>(
//     _token
//   );

//   return _userId?.data?.user_id || "";
// };

export const getUserId = () => {
  if (!hasENUID()) {
    return "";
  }

  const userId = getENUserId();

  return userId || "";
};
